<template>
  <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
  >
    <el-form ref="form" :model="brandForm" :rules="rules" label-width="100px" label-position="top">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item :label="$t('brandManage.communityName')" prop="communityId">
            <el-select v-model="brandForm.communityId" :placeholder="$t('brandManage.communityNamePlaceholder')" style="width: 100%">
              <el-option v-for="community in communities" :key="community.communityId" :label="community.name" :value="community.communityId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('brandManage.brandName')" prop="brandName">
            <el-input v-model="brandForm.brandName" :placeholder="$t('brandManage.brandNamePlaceholder')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('brandManage.phone')" prop="phone">
            <el-input v-model="brandForm.phone" :placeholder="$t('brandManage.phonePlaceholder')" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item :label="$t('brandManage.brandLogo')" prop="brandLogo">
            <div style="text-align: center">
              <el-image style="width: 178px; height: 178px; border: 1px dashed #ccc;" :src="brandForm.brandLogoUrl || '/img/noPhoto.jpg'" fit="cover" />
              <el-upload class="mt-10" :show-file-list="false" :before-upload="beforeUpload" :http-request="uploadImage" action="">
                <el-button size="small" type="primary">{{ $t('common.upload') }}</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="'营业时间'" prop="businessHours">
                <el-input v-model="brandForm.businessHours" type="textarea" :rows="2" placeholder="例如：周一至周日 09:00-21:00" />
              </el-form-item>
              <el-form-item :label="$t('brandManage.sort')" prop="sort">
                <el-input v-model="brandForm.sort" type="number" :placeholder="$t('brandManage.sortPlaceholder')" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('brandManage.state')" prop="state">
                <el-select v-model="brandForm.state" :placeholder="$t('brandManage.statePlaceholder')" style="width: 100%">
                  <el-option :label="$t('brandManage.stateOff')" value="1001" />
                  <el-option :label="$t('brandManage.stateOn')" value="2002" />
                </el-select>
              </el-form-item>
              <el-form-item :label="'店铺地址'" prop="storeAddress">
                <el-input v-model="brandForm.storeAddress" placeholder="请输入店铺地址" clearable />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('brandManage.brandDesc')" prop="brandDesc">
            <el-input v-model="brandForm.brandDesc" type="textarea" :rows="3" :placeholder="$t('brandManage.brandDescPlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'店铺说明'" prop="storeDesc">
            <el-input v-model="brandForm.storeDesc" type="textarea" :rows="3" placeholder="请输入店铺说明" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item :label="'品牌介绍'" prop="brandIntroduction">
        <rich-text-editor v-model="brandForm.brandIntroduction" :content="brandForm.brandIntroduction" />
      </el-form-item>
      <el-form-item :label="'员工'" prop="employees">
        <el-button type="primary" size="small" @click="addEmployee">添加员工</el-button>
        <div v-for="(employee, index) in brandForm.employees" :key="employee.id || index" class="employee-item">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-input v-model="employee.name" placeholder="姓名" />
            </el-col>
            <el-col :span="8">
              <el-input v-model="employee.phone" placeholder="手机号" />
            </el-col>
            <el-col :span="6">
              <el-input v-model="employee.position" placeholder="职务" />
            </el-col>
            <el-col :span="2">
              <el-button type="danger" size="small" @click="removeEmployee(index)">删除</el-button>
            </el-col>
          </el-row>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveBrand, updateBrand } from '@/api/shop/brandApi'
import { getCommunityId, getMyEnteredCommunitys } from '@/api/community/communityApi'
import { uploadImage as uploadImageApi } from '@/api/owner/ownerApi'
import RichTextEditor from '@/components/editor/RichTextEditor.vue'

export default {
  name: 'AddBrand',
  components: {
    RichTextEditor
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
      communities: [],
      brandForm: {
        brandId: '',
        brandName: '',
        brandLogo: '',
        brandLogoUrl: '',
        brandDesc: '',
        phone: '',
        businessHours: '',
        storeAddress: '',
        storeDesc: '',
        brandIntroduction: '',
        employees: [],
        sort: 0,
        state: '1001',
        communityId: getCommunityId()
      },
      rules: {
        communityId: [
          { required: true, message: '请选择小区', trigger: 'change' }
        ],
        brandName: [
          { required: true, message: this.$t('brandManage.brandNameRequired'), trigger: 'blur' },
          { max: 100, message: '品牌名称不能超过100个字符', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' },
          { type: 'number', message: '排序必须是数字', trigger: 'blur', transform: (value) => Number(value) }
        ]
      }
    }
  },
  methods: {
    async show(row) {
      // 加载小区列表
      await this.loadCommunities()

      if (row) {
        this.dialogTitle = this.$t('brandManage.editBrand')
        // 复制品牌数据
        this.brandForm = { ...row }

        // 确保 employees 数组存在且是响应式的
        console.log('Row employees:', row.employees)
        console.log('Row data:', row)
        
        // 直接设置员工数组，确保响应式
        if (!row.employees || !Array.isArray(row.employees)) {
          this.$set(this.brandForm, 'employees', [])
          console.log('Initialized employees array')
        } else {
          // 确保employees数组是响应式的，并且每个员工对象的字段名与前端模板一致
          console.log('Original employees:', row.employees)
          const formattedEmployees = row.employees.map((employee, index) => {
            console.log('Processing employee:', employee)
            return {
              id: employee.employeeId || employee.id || `emp_${Date.now()}_${index}`,
              name: employee.name || '',
              phone: employee.phone || '',
              position: employee.position || ''
            }
          })
          console.log('Formatted employees:', formattedEmployees)
          this.$set(this.brandForm, 'employees', formattedEmployees)
          console.log('Employees array after set:', this.brandForm.employees)
        }

        // 处理 brandLogo：如果是完整的 URL，提取 fileId
        if (row.brandLogoUrl && row.brandLogoUrl.includes('fileId=')) {
          const fileIdMatch = row.brandLogoUrl.match(/fileId=([^&]+)/)
          if (fileIdMatch && fileIdMatch[1]) {
            this.brandForm.brandLogo = fileIdMatch[1]
          }
        }
        // 设置品牌Logo URL
        this.brandForm.brandLogoUrl = row.brandLogoUrl || '/img/noPhoto.jpg'
        // 将 sort 字段转换为数字类型
        if (this.brandForm.sort !== undefined && this.brandForm.sort !== null) {
          this.brandForm.sort = Number(this.brandForm.sort)
        }
      } else {
        this.dialogTitle = this.$t('brandManage.addBrand')
        this.resetForm()
      }
      this.dialogVisible = true
      console.log('Brand form after show:', this.brandForm)
    },
    async loadCommunities() {
      try {
        const response = await getMyEnteredCommunitys({ page: 1, row: 100 })
        if (response.code === 0 && response.communitys) {
          this.communities = response.communitys
        }
      } catch (error) {
        console.error('Failed to load communities:', error)
      }
    },
    resetForm() {
      this.brandForm = {
        brandId: '',
        brandName: '',
        brandLogo: '',
        brandLogoUrl: '',
        brandDesc: '',
        phone: '',
        businessHours: '',
        storeAddress: '',
        storeDesc: '',
        brandIntroduction: '',
        employees: [],
        sort: 0,
        state: '1001',
        communityId: getCommunityId()
      }
    },
    addEmployee() {
      console.log('addEmployee method called')
      if (!this.brandForm.employees || !Array.isArray(this.brandForm.employees)) {
        // 确保employees数组是响应式的
        this.$set(this.brandForm, 'employees', [])
        console.log('Initialized employees array')
      }
      // 使用Vue的$set方法添加新员工，确保响应式更新
      const newEmployee = {
        id: `emp_${Date.now()}`,
        name: '',
        phone: '',
        position: ''
      }
      this.brandForm.employees.push(newEmployee)
      // 强制更新视图
      this.$forceUpdate()
      console.log('Added new employee, total employees:', this.brandForm.employees.length)
      console.log('New employee:', newEmployee)
    },
    removeEmployee(index) {
      this.brandForm.employees.splice(index, 1)
    },

    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    async uploadImage({ file }) {
      try {
        console.log('Starting upload with file:', file)
        const res = await uploadImageApi({ file })
        console.log('Upload response:', res)
        console.log('Response type:', typeof res)
        console.log('Response keys:', Object.keys(res))
        this.brandForm.brandLogo = res.fileId
        this.brandForm.brandLogoUrl = res.url
        console.log('Brand form after upload:', this.brandForm)
        this.$forceUpdate()
      } catch (error) {
        console.error('Upload error:', error)
        console.error('Error message:', error.message)
        console.error('Error stack:', error.stack)
        this.$message.error('上传失败')
      }
    },
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            // 准备提交数据
            const submitData = { ...this.brandForm }

            // 处理员工信息，确保字段名与后端一致
            if (Array.isArray(submitData.employees)) {
              submitData.employees = submitData.employees.map(employee => ({
                employeeId: employee.id && employee.id.startsWith('emp_') ? undefined : employee.id,
                name: employee.name,
                phone: employee.phone,
                position: employee.position
              }))
            }

            let response
            if (this.brandForm.brandId) {
              response = await updateBrand(submitData)
            } else {
              response = await saveBrand(submitData)
            }
            // axios 响应的 data 字段才是 API 返回的实际数据
            const apiResponse = response.data
            if (apiResponse.code === 0) {
              this.$message.success(this.$t('common.operationSuccess'))
              this.dialogVisible = false
              this.$emit('success')
            } else {
              this.$message.error(apiResponse.msg)
            }
          } catch (error) {
            console.error('Failed to save brand:', error)
            this.$message.error(this.$t('brandManage.saveFailed'))
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.employee-item {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.brand-intro-upload {
  margin-top: 10px;
}
</style>